import { Helmet } from "react-helmet";

export interface threatMetrixScriptProps {
  sessionId: string | undefined;
}

export default function ThreatMetrixScript({
  sessionId,
}: threatMetrixScriptProps) {

  var tmxEnabled:Boolean = document.querySelector('meta[data-enable-tmx]')?.dataset?.enableTmx == "true";
  var tmxUrl:string = document.querySelector('meta[data-tmx-url]')?.dataset?.tmxUrl;
  var tmxOrgId:string = document.querySelector('meta[data-tmx-orgid]')?.dataset?.tmxOrgid;

  return (
    <>
      {tmxEnabled && (
        <Helmet>
          <script
            src={`${tmxUrl}org_id=${tmxOrgId}&session_id=${sessionId}`}
            id="tmxScript"
          ></script>
        </Helmet>
      )}
    </>
  );
}
